import { ContactUsModel, IContactUsContent } from '@/interfaces/pages/contact-us-form.interface';
import { RequestServices as _http } from '../common/request.services';
import { getContactUsContent, contactUsSendEmail } from '@/constants/forms-api.const';

export const ContactUsOnlineService = {
  /**
   * Get const us content
   *
   * @returns
   */
  async getContactUsContent(): Promise<IContactUsContent> {
    return await _http.HttpGet(getContactUsContent);
  },

  /**
   * send email
   *
   * @returns
   */
  async sendContactUsEmail(model: ContactUsModel): Promise<boolean> {
    return await _http.HttpPost(contactUsSendEmail, model);
  },
};
